/** The Testimonials library's Bunny pull zone (same constant as WolCard). */
export const TESTIMONIALS_CDN_HOSTNAME = 'vz-166e7b4e-081.b-cdn.net';

/**
 * A video testimonial's poster picture (2026-09-27, Wall of Love 403 fix):
 * our media-host copy from the feed (video.posterUrl — media.pianofantasy.com
 * on production), so crawlers get 200. Falls back to the pull-zone thumbnail,
 * which answers only allowed referrers, when the feed has no copy.
 */
export function testimonialPosterSrc(video: { guid: string; posterUrl?: string | null }): string {
  return video.posterUrl ?? `https://${TESTIMONIALS_CDN_HOSTNAME}/${encodeURIComponent(video.guid)}/thumbnail.jpg`;
}
